export type CollapsibleEventDetail = {
    action: "open";
    context: string;
    id: string;
};

export class CollapsibleEvent extends CustomEvent<CollapsibleEventDetail> {
    public static readonly KEY = "collapsible";

    public constructor(eventInitDict: CustomEventInit<CollapsibleEventDetail>) {
        super(CollapsibleEvent.KEY, eventInitDict);
    }
}
